import {
    CLAN_INVITES_REQUEST_SUCCESS,
    CLAN_INVITES_REQUEST_ERROR,
    CLAN_INVITES_CHECKED,
} from 'state/actions/clan_invites'

export const initialState = {
    total: null,
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
    case CLAN_INVITES_REQUEST_SUCCESS: {
        return {
            ...state,
            total: action.payload.total,
        }
    }
    case CLAN_INVITES_REQUEST_ERROR: {
        return {
            ...state,
            errorMessage: action.payload.errorMessage,
        }
    }
    case CLAN_INVITES_CHECKED: {
        return {
            ...state,
            total: 0,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clan_invites.js